<template>
  <div class="upload">
    <el-upload class="uploadvideo" action="" multiple :accept="allowFileType" :auto-upload="false"
      :show-file-list="false" :on-change="handleChange">
      <el-button size="mini" style="font-size:12px;padding: 10px" v-if="text != '批量上传'" slot="trigger" round
        class="bgc-bv">课件批量上传</el-button>
      <span v-else style="color: #58B5DD;font-size:14px;">批量上传</span>
    </el-upload>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
export default {
  data() {
    return {
      allowFileType: ".mp4,.MP4",
      //组件对象
      uploader: null,
    };
  },
  props: ['text'],
  created() { },
  methods: {
    // 特殊字符校验规则
    checkReg(val, regName) {
      let reg = {
        userName: /^[a-zA-Z0-9_]{2,16}$/,
        password: /^[A-Za-z0-9]+$/,
        fullName: /^[\u4e00-\u9fa5]+$/,
        caseAndNumber: /^[A-Za-z0-9]+$/,
        code: /^[A-Za-z0-9_-]+$/,
        phone: /^((0\d{2,3}-\d{7,8})|(0\d{9,11})|(1\d{10})|(\d{7,8}))$/,
        mobile: /^1\d{10}$/,
        fileName: new RegExp('[\\\\/:*?"<>|]'),
        eMall: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      };
      return reg[regName].test(val);
    },
    // 文件基本信息校验
    beforeUpload(file) {
      let that = this;
      //文件名不能超长
      let fileName = file.name;
      if (fileName.length > 100) {
        that.$message.warning({
          message: "资源文件名称不能大于100个字符！",
          duration: 1000
        });
        return false;
      }
      // 不能还有特殊字符
      if (that.checkReg(fileName, "fileName")) {
        that.$message.warning({
          message: "资源文件[" + fileName + "]名称不能包含特殊字符！",
          duration: 1000
        });
        return false;
      }
      //校验文件类型，是否允许上传
      let fileType = file.name.split(".");
      if (!that.allowFileType.includes(fileType[fileType.length - 1])) {
        that.$message.warning({
          message: "只能上传.MP4格式的文件！",
          duration: 1000
        });
        return false;
      }
      return true;
    },
    // 文件列表改变回调
    handleChange(file, fileList) {
      //校验文件
      if (this.beforeUpload(file)) {
        this.uploader = this.createUploaderHw();
        this.uploader.addFile(file);
        //删除之前的文件。
        this.fileList = fileList.slice(-1);
        //修改为验证文件通过后直接开始上传的模式
        this.showProgress = true;
        this.authUpload();
      } else {
        this.fileList = [];
      }
    },
    // 开始上传
    authUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
      } else {
        this.$message("您还未选择上传视频！");
      }
    },
    // 创建华为上传对象
    createUploaderHw() {
      let that = this;
      return {
        fileList: [],
        stopUploadStatus: false,
        fileContentType: "video/mp4",
        addFile(file) {
          file.forData = {
            // 文件分段计数
            partNumber: 1,
            // 文件读取位置
            position: 0,
            // 用于将文件对象分割成多个部分
            blobSlice: File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
            // 大小
            bufferSize: 1024 * 1024 * 10,
          };
          this.fileList.push(file);
        },
        stopUpload() {
          this.onUploadCanceled()
          this.stopUploadStatus = true;
        },
        startUpload() {
          this.stopUploadStatus = false;
          this.fileList.forEach(async file => {
            if (this.stopUploadStatus) {
              return;
            }
            let fileName = file.name;
            let createAssetByFileUpReq = {
              fileName: fileName,
              title: fileName,
              videoName: fileName,
              videoType: 'MP4'
            }
            try {
              // 获取 - 点播媒资数据
              let res = await that.$post("/sys/hw/vod/createAssetByFileUp", createAssetByFileUpReq, 3000, false);
              file.dispName = file.name;
              file.videoId = res.data.asset_id;
              file.kpointLessonNum = 1;
              that.$emit('onAddFile', file);
              await this.getInitAuth(res.data.target.bucket, res.data.target.object, res.data.asset_id, file);
            } catch (e) {
              this.onUploadFailed(e.message)
              that.$message.error("上传失败");
            }
          })
        },
        // 获取[初始化上传任务]授权，获得授权的url
        async getInitAuth(bucket, object, asset_id, file) {
          let initPartUploadAuthorityReq = {
            bucket: bucket,
            fileContentType: this.fileContentType,
            object: object,
          };
          let res = await that.$post("/sys/hw/vod/initPartUploadAuthority", initPartUploadAuthorityReq, 3000, false);
          this.initPartUpload(res.data, bucket, object, asset_id, file);
        },
        initPartUpload(sign_url, bucket, object, asset_id, file) {
          let resp = this.sendRequest("POST", sign_url, null, { "Content-Type": "video/mp4" });
          let domParser = new DOMParser();
          let dom = domParser.parseFromString(resp, "text/xml");
          let uploadId = dom.getElementsByTagName("UploadId")[0].firstChild.nodeValue;
          this.readAndUpload(bucket, object, asset_id, uploadId, file)
        },
        // 循环上传分段
        readAndUpload(bucket, object, asset_id, uploadId, file) {
          if (this.stopUploadStatus) {
            return;
          }
          let _this = this;
          let fileReader = new FileReader();
          fileReader.onload = async function (e) {
            // 先文件分段md5
            const md5 = that.$md5(e.target.result);
            // md5转字节数组
            let bmd5 = that.$Str2Bytes(md5);
            // base64 encode md5字节数组
            let content_md5 = that.$base64js.fromByteArray(bmd5);
            // 5.获取分段上传授权
            let sign_url = await _this.getPartUploadAuthority(content_md5, bucket, object, asset_id, uploadId,file);
            // 6.上传分段
            _this.uploadPartFile(content_md5, e.target.result, sign_url);
            file.forData.partNumber++;
            // 判断是否读完，未读完继续上传
            if (file.forData.position + file.forData.bufferSize < file.size) {
              file.forData.position += file.forData.bufferSize;
              _this.readAndUpload(bucket, object, asset_id, uploadId, file);
            } else {
              file.forData.position = file.size;
              // 全部上传完成后执行后续步骤
              await _this.afterUpload(bucket, object, asset_id, uploadId, file);
            }
            _this.onUploadProgress(file,file.forData.position / file.size);
          }
          let blob = file.forData.blobSlice.call(file.raw, file.forData.position, file.forData.position + file.forData.bufferSize);
          fileReader.readAsArrayBuffer(blob);
        },
        // 上传分段
        uploadPartFile(contentMd5, content, sign_url) {
          let headers = {
            "Content-Type": "application/octet-stream",
            "Content-MD5": contentMd5
          }
          let resp = this.sendRequest("PUT", sign_url, content, headers);
        },
        sendRequest(method, url, data, headers) {
          var xhr = new XMLHttpRequest();
          xhr.open(method, url, false);
          for (let i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }
          xhr.send(data);
          return xhr.responseText;
        },
        async getPartUploadAuthority(content_md5, bucket, object, asset_id, uploadId,file) {
          let res = await that.$post("/sys/hw/vod/getPartUploadAuthority", {
            bucket: bucket,
            contentMd5: content_md5,
            fileContentType: this.fileContentType,
            object: object,
            partNumber: file.forData.partNumber,
            uploadId: uploadId
          }, 3000, false)
          return res.data;
        },
        async afterUpload(bucket, object, asset_id, uploadId, file) {
          // 8.获取列举已上传段授权、获取已上传段、获取合并段授权、合并段、确认上传五合一
          let assetId = await this.mergeUploadedPartAndConfirmUpload(bucket, object, asset_id, uploadId, file);
          this.onUploadSucceed(assetId);
          this.onUploadEnd();
        },
        async mergeUploadedPartAndConfirmUpload(bucket, object, asset_id, uploadId, file) {
          let res = await that.$post("/sys/hw/vod/mergeUploadedPartAndConfirmUpload", {
            bucket: bucket,
            object: object,
            assetId: asset_id,
            uploadId: uploadId
          }, 3000, false)
          return res.data;
        },
        //文件上传成功
        onUploadSucceed: function (videoId) {
          that.statusText = "文件上传成功!";
          that.$emit('fileUploadSuccess', videoId);
        },
        // 文件上传失败
        onUploadFailed: function (message) {
          that.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: function () {
          that.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (file,progress) {
          that.$emit('fileUploadProgress', progress, file.videoId);
          that.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // TODO
        },
        // 全部文件上传结束
        onUploadEnd: function () {
          that.statusText = "文件上传完毕";
        }
      }
    }
  }
};
</script>
<style lang="less">
.upload {
  .uploadvideo {
    display: flex;

    .el-upload {
      height: auto !important;
      border: none;
    }
  }

  .el-button {
    height: auto !important;
  }
}
</style>
